export default class ProductSwitch {
    constructor() {
        this.element = '[data-switch]';
        this.resultLinkSelector = '[data-switch-link]';
        this.linkReviewTuev = '[data-switch-tuev]';
        this.labelCssClass = 'product-button__label';
        this.init();
    }

    init() {
        // early exit
        const self = document.querySelector(this.element);
        if (self === null) {
            return false;
        }

        const resultLink = document.querySelector(this.resultLinkSelector);
        const tuevReviewLink = document.querySelector(this.linkReviewTuev);

        const labels = self.querySelectorAll(`.${this.labelCssClass}`);

        labels.forEach((label) => {
            label.addEventListener('click', (e) => {
                const inputId = e.currentTarget.getAttribute('for');
                const input = document.querySelector(`#${inputId}`);
                const link = input.getAttribute('data-href');
                const linkReviewTuev = input.getAttribute('data-review-link-tuev');
                if (resultLink !== null && link !== null) {
                    resultLink.setAttribute('href', link);
                }
                if (tuevReviewLink !== null && linkReviewTuev !== null) {
                    tuevReviewLink.setAttribute('href', linkReviewTuev);
                }
            });
        });
    }
}
